import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Observable, Subject } from 'rxjs';
@Injectable()
export class LocalStorageService {
    
    private storageSub= new Subject<String>();
    watchSpecificKeys = ['isRoleChange']

    constructor(@Inject(LOCAL_STORAGE) private storage: StorageService) { }


    watchStorage(): Observable<any> {
        return this.storageSub.asObservable();
    }

    public setData(key:string, value:string|object):void {
        // this.clearData()
        if(value instanceof Object){
            value = JSON.stringify(value)
        }
        // insert value to local storage
        this.storage.set(key, value);
        if(this.watchSpecificKeys.includes(key)){
            this.storageSub.next(key);
        }
    }

    public getData(key:string){
        // get value from local storage
        let value = this.storage.get(key);
        try { 
            value = JSON.parse(value); 
            return value; 
        } catch (error) { 
            return value; 
        } 
    }

    public removeData(key:string):void {
        // remove value from local storage
        this.storage.remove(key);
    }

    public isCheck(key:string){
        return this.storage.has(key)
    }

    public clearData():void{
        this.storage.clear()
    }

    public isActiveUser(){
        return this.isCheck('userData') && this.isCheck('accessToken')
    }
}